module.exports = __webpack_public_path__ + "img/swiper_3.0_4_1.f4b5635e.webp";